export default __webpack_public_path__ + "static/media/512.fd6e2ef1.jpg";